export default [
  {
    name: 'unit-command-create',
    path: '/unit-commands/create',
    component: () => import('@/views/units/unit-commands/UnitCommandManage')
  },
  {
    name: 'unit-command-edit',
    path: '/unit-commands/:id/edit',
    component: () => import('@/views/units/unit-commands/UnitCommandManage')
  },
  {
    name: 'unit-command-view',
    path: '/unit-commands/:id/view',
    component: () => import('@/views/units/unit-commands/UnitCommandManage')
  },
  {
    name: 'unit-command-find',
    path: '/unit-commands/find',
    component: () => import('@/views/units/unit-commands/UnitCommandFind')
  },
  {
    name: 'unit-command-permission',
    path: '/unit-commands/permission',
    component: () => import('@/views/units/unit-command-permissions/UnitCommandPermissionManage')
  },
  {
    name: 'unit-command-log',
    path: '/unit-commands/log',
    component: () => import('@/views/units/unit-commands/UnitCommandLogFind')
  }
]



// WEBPACK FOOTER //
// ./src/router/routeUnitCommands.js